import styles from "./Resume.module.css";
import ResumeContent from "../../components/Resume/ResumeContent";
import Navbar from "../../components/Navbar/Navbar";
export default function Resume() {
	return (
		<>
			<Navbar />
			<div id="main-content" className={styles.container}>
				<ResumeContent />
			</div>
		</>
	);
}
